export function FeedbackButton() {
  return (
    <div className="absolute top-0 right-5 py-1 px-3 border-solid border border-slate-7 text-[10px] font-bold bg-slate-3 z-50">
      <a href="https://comms.canny.io/comms-feature-requests" className="uppercase" target="_blank" rel="noreferrer">
        Feedback
      </a>
    </div>
  );
}
